import { CourseScreen } from '@screens/CourseScreen'

export default function Course() {
  return <CourseScreen />
}
